import {css} from 'lit';
export const styles = css`iron-image {
    width: 100%;
    height: 100%;
}
`;
export default styles;
